// Main application entry point
// console.log('Exploit3rs website initialized'); // Removed

// Detect if we're in production or development
const isProduction = window.location.hostname.includes('exploit3rs.ae');

// Add a function to ensure critical CSS is loaded for all pages
const ensureCriticalCSS = () => {
  // Critical CSS files that should be present on all pages - adjust paths for production
  const criticalCSS = [
    { href: '/styles/reset.css', rel: 'stylesheet' },
    { href: '/styles/variables.css', rel: 'stylesheet' },
    { href: '/styles/utilities.css', rel: 'stylesheet' },
    { href: '/styles/global.css', rel: 'stylesheet' },
    { href: '/components/header.css', rel: 'stylesheet' },
    { href: '/components/footer.css', rel: 'stylesheet' },
    // Preloads for faster loading
    { href: '/components/header.css', rel: 'preload', as: 'style' },
    { href: '/components/footer.css', rel: 'preload', as: 'style' }
  ];
  
  // Check for each critical CSS file and add if missing
  criticalCSS.forEach(css => {
    const selector = css.rel === 'preload' 
      ? `link[rel="preload"][href="${css.href}"]`
      : `link[rel="stylesheet"][href="${css.href}"]`;
      
    if (!document.querySelector(selector)) {
      const link = document.createElement('link');
      link.rel = css.rel;
      link.href = css.href;
      if (css.as) link.setAttribute('as', css.as);
      document.head.appendChild(link);
    }
  });
  
  // Add FOUC prevention style if not already present
  if (!document.querySelector('style#fouc-prevention')) {
    const style = document.createElement('style');
    style.id = 'fouc-prevention';
    style.textContent = `
      #header.loading {
        opacity: 0;
        transition: opacity 0.3s ease;
      }
      #header {
        opacity: 1;
      }
    `;
    document.head.appendChild(style);
  }
  
  // Add loading class to header if not already present
  const header = document.getElementById('header');
  if (header && !header.classList.contains('loading')) {
    header.classList.add('loading');
  }
  
  // Add failsafe timer to ensure header becomes visible even if there are errors
  // This is crucial for production where errors might prevent normal class removal
  setTimeout(() => {
    const header = document.getElementById('header');
    if (header && header.classList.contains('loading')) {
      console.log('Failsafe: Removing loading class from header after timeout');
      header.classList.remove('loading');
    }
  }, 3000); // 3 second failsafe
};

// Run this immediately to prevent FOUC
ensureCriticalCSS();

// Make available as global variable instead of export to avoid module loading issues
window.pageLoadTime = new Date().toISOString();

// Helper to determine if we're on a service page
const isServicePage = () => {
  const path = window.location.pathname;
  
  // Check if path starts with /services/
  if (path.startsWith('/services/')) {
    // console.log(`Service subpage detected: ${path}`); // Removed
    return true;
  }
  
  return false;
};

// Helper to determine if we're on the home page
const isHomePage = () => {
  const path = window.location.pathname;
  return path === '/' || path === '/index.html';
};

// Log page load performance
window.addEventListener('load', () => {
  // Basic performance metrics
  if (window.performance) {
    try {
      const perfData = window.performance.timing;
      const pageLoadTime = perfData.loadEventEnd > perfData.navigationStart ? 
                          perfData.loadEventEnd - perfData.navigationStart : 
                          'not available';
      const domReadyTime = perfData.domComplete - perfData.domLoading;
      const responseTime = perfData.responseEnd - perfData.requestStart;
      const domProcessing = perfData.domComplete - perfData.domInteractive;
      const renderTime = perfData.loadEventEnd > perfData.domComplete ? 
                        perfData.loadEventEnd - perfData.domComplete : 
                        'not available';
    } catch (error) {
      console.error('Error calculating performance metrics:', error);
    }
  }
  // Don't import scripts here anymore
});

// Setup Header/Footer logic on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
  // console.log('App initialized'); // Removed
  
  // Enhanced component loader with better error handling and MIME type support
  const loadComponent = async (containerId, componentPath) => {
    // Get container reference outside try/catch to avoid redeclaration
    const container = document.getElementById(containerId);
    if (!container) {
      console.error(`Container element #${containerId} not found`);
      return false;
    }
    
    try {
      // Add loading class to container first to prevent FOUC
      container.classList.add('loading');
      
      // Adjust paths for production if needed
      let adjustedPath = componentPath;
      if (isProduction) {
        // In production, only use /components/ paths, not /src/components/
        adjustedPath = componentPath.replace('/src/components/navigation/', '/components/');
      }
      
      // First load CSS - preload it to improve loading speed
      let cssLoaded = false;
      try {
        const cssPath = adjustedPath.replace('.html', '.css');
        cssLoaded = await loadComponentCSS(cssPath);
      } catch (cssError) {
        console.error('CSS loading error:', cssError);
        // Continue despite CSS error - we'll handle display without it
      }
      
      // Then fetch and inject HTML content
      const cacheBuster = `?v=${new Date().getTime()}`;
      const customHeaders = {
        'Accept': 'text/html',
        'X-Requested-With': 'XMLHttpRequest',
        'Pragma': 'no-cache',
        'Cache-Control': 'no-cache'
      };
      
      const response = await fetch(`${adjustedPath}${cacheBuster}`, {
        headers: customHeaders
      });
      
      if (!response.ok) {
        throw new Error(`Failed to load component: ${response.status} ${response.statusText}`);
      }
      
      const html = await response.text();
      container.innerHTML = html;
      
      // Finally, load the JS file to ensure it runs after HTML and CSS are loaded
      try {
        const jsPath = adjustedPath.replace('.html', '.js');
        await loadComponentJS(jsPath);
      } catch (jsError) {
        console.error('JS loading error:', jsError);
        // Continue despite JS error - the HTML is already injected
      }
      
      // Remove loading class after everything is loaded, with proper error handling
      try {
        setTimeout(() => {
          if (container.classList.contains('loading')) {
            container.classList.remove('loading');
            console.log(`Removed loading class from ${containerId}`);
          }
        }, 50);
      } catch (removeError) {
        console.error('Error removing loading class:', removeError);
        // Force removal as a last resort
        container.className = container.className.replace(/\bloading\b/g, '');
      }
      
      return true;
    } catch (error) {
      console.error(`Error loading component ${componentPath}:`, error);
      
      // Ensure loading class is removed even if component loading fails
      if (container.classList.contains('loading')) {
        container.classList.remove('loading');
      }
      
      // Try alternate paths if the first attempt failed
      if (!componentPath.includes('/components/') && !componentPath.includes('/src/components/')) {
        // If we didn't use a specific path format, try both formats
        try {
          // Try with /components/ format (production)
          const prodPath = `/components/${componentPath.split('/').pop()}`;
          console.log(`Trying production path: ${prodPath}`);
          return await loadComponent(containerId, prodPath);
        } catch (prodError) {
          // Try with /src/components/ format (development)
          try {
            const devPath = `/src/components/navigation/${componentPath.split('/').pop()}`;
            console.log(`Trying development path: ${devPath}`);
            return await loadComponent(containerId, devPath);
          } catch (devError) {
            console.error(`Failed to load from any path`);
          }
        }
      }
      
      // Fallback content instead of complete failure
      if (containerId === 'header') {
        container.innerHTML = `
      <header class="header">
        <div class="container header__container">
          <a href="/" class="header__logo">
            <img src="/assets/images/logo/white.png" alt="Exploit3rs" />
          </a>
                <div class="header__nav-group">
                  <nav class="header__nav">
                    <a href="/services" class="header__nav-item">SERVICES</a>
                    <a href="/about" class="header__nav-item">ABOUT US</a>
                  </nav>
                </div>
        </div>
      </header>
          `;
          
        // Still need to remove loading class for fallback
        setTimeout(() => {
          if (container.classList.contains('loading')) {
            container.classList.remove('loading');
          }
        }, 50);
      } else if (containerId === 'footer') {
        container.innerHTML = `
      <footer class="footer">
        <div class="footer__bottom">
                <div class="container footer__bottom-content">
                  <p class="footer__copyright">&copy; ${new Date().getFullYear()} Exploit3rs. All rights reserved.</p>
          </div>
        </div>
      </footer>
    `;
      }
      
      // Ensure loading class is removed in the fallback case too
      setTimeout(() => {
        if (container.classList.contains('loading')) {
          container.classList.remove('loading');
        }
      }, 100);
      
      return false;
    }
  };

  // Helper function to load component CSS
  const loadComponentCSS = async (cssPath) => {
    try {
      // Check if CSS is already loaded to prevent duplicates
      const existingLink = document.querySelector(`link[href^="${cssPath}"]`);
      if (existingLink) {
        return true;
      }
  
      // Add cache buster to prevent caching issues
      const cacheBuster = `?v=${new Date().getTime()}`;
      
      // Create a new link element for the CSS
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = `${cssPath}${cacheBuster}`;
      link.type = 'text/css';
      
      // Create a promise to handle load/error events
      return new Promise((resolve, reject) => {
        link.onload = () => {
          resolve(true);
        };
        
        link.onerror = async (err) => {
          console.error(`Failed to load CSS ${cssPath}`, err);
          
          // Try alternate paths based on environment
          if (isProduction) {
            // In production, try the direct /css/ path
            const basename = cssPath.split('/').pop();
            const prodPath = `/css/${basename}`;
            
            const prodLink = document.createElement('link');
            prodLink.rel = 'stylesheet';
            prodLink.href = `${prodPath}${cacheBuster}`;
            prodLink.type = 'text/css';
            
            prodLink.onload = () => {
              console.log(`Successfully loaded CSS from ${prodPath}`);
              resolve(true);
            };
            
            prodLink.onerror = () => {
              reject(new Error(`Failed to load CSS from any path: ${cssPath}`));
            };
            
            document.head.appendChild(prodLink);
          } else {
            // In development, try alternative paths
            // ... existing dev mode fallback code ...
            reject(err);
          }
        };
        
        document.head.appendChild(link);
      });
    } catch (error) {
      console.error(`Error loading component CSS ${cssPath}:`, error);
      return false;
    }
  };
  
  // Helper function to load component JS
  const loadComponentJS = async (jsPath) => {
    try {
      // console.log(`Loading script from ${jsPath}`); // Removed
      
      // Check if script is already loaded to prevent duplicates
      const existingScript = document.querySelector(`script[src^="${jsPath}"]`);
      if (existingScript) {
        // console.log(`Script ${jsPath} already loaded`); // Removed
        return true;
      }
  
      // Add cache buster to prevent caching issues
      const cacheBuster = `?v=${new Date().getTime()}`;
      
      // Return a promise to handle script loading
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = `${jsPath}${cacheBuster}`;
        script.type = 'module'; // Use ES modules format
        
        // Add attributes to prevent MIME type issues
        script.setAttribute('charset', 'utf-8');
        
        script.onload = () => {
          // console.log(`Script ${jsPath} loaded successfully`); // Removed
          resolve(true);
        };
        
        script.onerror = (err) => {
          console.error(`Failed to load script ${jsPath}`, err);
          
          // Try alternate path if in production
          if (jsPath.includes('/src/components/')) {
            const alternatePath = jsPath.replace('/src/components/', '/components/');
            // console.log(`Attempting to load script from production path: ${alternatePath}`); // Removed
            
            const alternateScript = document.createElement('script');
            alternateScript.src = `${alternatePath}${cacheBuster}`;
            alternateScript.type = 'module';
            alternateScript.setAttribute('charset', 'utf-8');
            
            alternateScript.onload = () => {
              // console.log(`Script ${alternatePath} loaded successfully`); // Removed
              resolve(true);
            };
            
            alternateScript.onerror = () => {
              console.error(`Failed to load script from production path: ${alternatePath}`);
              
              // As a last resort, try direct path without src or components prefixes
              const basePath = jsPath.split('/').pop();
              const simplePath = `/js/${basePath}`;
              // console.log(`Attempting to load script from simplified path: ${simplePath}`); // Removed
              
              const simpleScript = document.createElement('script');
              simpleScript.src = `${simplePath}${cacheBuster}`;
              simpleScript.type = 'module';
              simpleScript.setAttribute('charset', 'utf-8');
              
              simpleScript.onload = () => {
                // console.log(`Script ${simplePath} loaded successfully`); // Removed
                resolve(true);
              };
              
              simpleScript.onerror = () => {
                console.error(`Failed to load script from any path: ${jsPath}, ${alternatePath}, ${simplePath}`);
                reject(new Error(`Failed to load script from any path: ${jsPath}`));
              };
              
              document.body.appendChild(simpleScript);
            };
            
            document.body.appendChild(alternateScript);
          } else if (jsPath.includes('/components/')) {
            const alternatePath = jsPath.replace('/components/', '/src/components/');
            // console.log(`Attempting to load script from development path: ${alternatePath}`); // Removed
            
            const alternateScript = document.createElement('script');
            alternateScript.src = `${alternatePath}${cacheBuster}`;
            alternateScript.type = 'module';
            alternateScript.setAttribute('charset', 'utf-8');
            
            alternateScript.onload = () => {
              // console.log(`Script ${alternatePath} loaded successfully`); // Removed
              resolve(true);
            };
            
            alternateScript.onerror = () => {
              console.error(`Failed to load script from development path: ${alternatePath}`);
              reject(new Error(`Failed to load script from any path: ${jsPath} and ${alternatePath}`));
            };
            
            document.body.appendChild(alternateScript);
          } else {
            reject(err);
          }
        };
        
        document.body.appendChild(script);
      });
    } catch (error) {
      console.error(`Error loading component JS ${jsPath}:`, error);
      return false;
    }
  };

  // Define paths with a clear preference order
  const headerPaths = [
    '/components/header.html',      // Production path (first priority)
    '/src/components/navigation/header/header.html'   // Development path (second priority)
  ];
  
  const footerPaths = [
    '/components/footer.html',      // Production path (first priority)
    '/src/components/navigation/footer/footer.html'   // Development path (second priority)
  ];
  
  // Try loading header from multiple paths sequentially
  const loadHeaderComponent = async () => {
    for (const path of headerPaths) {
      try {
        const result = await loadComponent('header', path);
        if (result) return; // Exit after first successful load
      } catch (err) {
        // Continue to next path
      }
    }
    console.error('Failed to load header component from any path');
  };
  
  // Try loading footer from multiple paths sequentially
  const loadFooterComponent = async () => {
    for (const path of footerPaths) {
      try {
        const result = await loadComponent('footer', path);
        if (result) return; // Exit after first successful load
      } catch (err) {
        // Continue to next path
      }
    }
    console.error('Failed to load footer component from any path');
  };
  
  // Add a debug utility for component path verification (runs in production mode only)
  const verifyComponentPaths = async () => {
    if (!isProduction) return;
    
    console.log('Verifying component paths in production environment...');
    
    const pathsToCheck = [
      '/components/header.html',
      '/components/header.css',
      '/components/footer.html',
      '/components/footer.css',
      '/css/home.css',
      '/styles/global.css',
      '/styles/reset.css',
      '/styles/variables.css',
      '/styles/utilities.css'
    ];
    
    // Add a small debug element that will be hidden in normal view
    const debugDiv = document.createElement('div');
    debugDiv.style.position = 'fixed';
    debugDiv.style.right = '0';
    debugDiv.style.bottom = '0';
    debugDiv.style.backgroundColor = 'rgba(0,0,0,0.7)';
    debugDiv.style.color = 'white';
    debugDiv.style.padding = '10px';
    debugDiv.style.fontSize = '10px';
    debugDiv.style.maxHeight = '200px';
    debugDiv.style.maxWidth = '300px';
    debugDiv.style.overflow = 'auto';
    debugDiv.style.zIndex = '9999';
    debugDiv.style.display = 'none'; // Hidden by default
    
    document.body.appendChild(debugDiv);
    
    // Press CTRL+SHIFT+D to toggle the debug panel
    document.addEventListener('keydown', (e) => {
      if (e.ctrlKey && e.shiftKey && e.key === 'D') {
        debugDiv.style.display = debugDiv.style.display === 'none' ? 'block' : 'none';
      }
    });
    
    // Check each path
    for (const path of pathsToCheck) {
      try {
        const response = await fetch(path, { method: 'HEAD' });
        const status = response.ok ? '✅' : '❌';
        const contentType = response.headers.get('content-type') || 'Not specified';
        debugDiv.innerHTML += `<div>${status} ${path} - ${contentType}</div>`;
      } catch (error) {
        debugDiv.innerHTML += `<div>❌ ${path} - Error: ${error.message}</div>`;
      }
    }
  };
  
  // Load components in sequence to prevent race conditions
  const loadComponents = async () => {
    await loadHeaderComponent();
    await loadFooterComponent();
    // Only verify paths in production to help debug issues
    if (isProduction) {
      await verifyComponentPaths();
    }
  };
  
  // Start loading components
  loadComponents();
});

// Initialize just the common components like header/footer
function initCommonComponents() {
  // --- HEADER LOGIC START ---
  const header = document.querySelector('.header');
  const mobileNav = document.querySelector('.header__mobile-nav');
  const megaMenu = document.getElementById('mega-menu');
  const allMenuButton = document.getElementById('all-menu-button');
    
  // console.log('Header elements lookup:', { // Removed
  //     header: !!header,
  //     mobileNav: !!mobileNav,
  //     megaMenu: !!megaMenu,
  //     allMenuButton: !!allMenuButton
  // });
  
  // Only continue with header logic if the elements exist
  if (header && allMenuButton) {
    // Utility functions - MOVED UP before usage
    const isMobile = () => window.innerWidth <= 768;

    // Create overlay for mega menu if it doesn't exist
    let overlay = document.querySelector('.mega-menu-overlay');
    if (!overlay && !isMobile()) { // Only create overlay for desktop menu
        overlay = document.createElement('div');
        overlay.className = 'mega-menu-overlay';
        document.body.appendChild(overlay);
        // console.log('Created mega menu overlay'); // Removed
    }
      
    // Close all menus
    const closeAllMenus = () => {
        if (megaMenu && megaMenu.classList.contains('active')) {
            megaMenu.classList.remove('active');
            // console.log('Removed active class from megaMenu'); // Removed
        }
        if (allMenuButton && allMenuButton.classList.contains('active')) {
            allMenuButton.classList.remove('active');
            // console.log('Removed active class from allMenuButton'); // Removed
        }
        if (overlay && overlay.classList.contains('active')) {
            overlay.classList.remove('active');
            // console.log('Removed active class from overlay'); // Removed
        }
        if (document.body.classList.contains('mega-menu-open')) {
            document.body.classList.remove('mega-menu-open');
            // console.log('Removed mega-menu-open class from body'); // Removed
        }
        
        if (mobileNav && mobileNav.classList.contains('active')) {
            mobileNav.classList.remove('active');
            // console.log('Removed active class from mobileNav'); // Removed
        }
    };
      
    // Toggle appropriate menu based on viewport
    const toggleMenu = (e) => {
        if (e) {
    e.preventDefault();
    e.stopPropagation();
        }
        
        const mobile = isMobile();
        // console.log(`Toggle menu called, mobile: ${mobile}`); // Removed
    
        // Close existing menus first
        // Note: Calling closeAllMenus here might immediately close the menu we are about to open.
        // Instead, we check the button state in the click handler.
        
        // Add active state to the correct menu
        if (mobile) {
      if (mobileNav) {
                mobileNav.classList.add('active');
                // console.log('Added active class to mobileNav'); // Removed
                if (allMenuButton) { 
                    allMenuButton.classList.add('active');
                    // console.log('Added active class to allMenuButton (mobile)'); // Removed
                }
      }
    } else {
      if (megaMenu) {
        megaMenu.classList.add('active');
                // console.log('Added active class to megaMenu'); // Removed
                if (overlay) { 
                    overlay.classList.add('active');
                    // console.log('Added active class to overlay'); // Removed
                }
                if (allMenuButton) { 
                    allMenuButton.classList.add('active');
                    // console.log('Added active class to allMenuButton (desktop)'); // Removed
                }
                document.body.classList.add('mega-menu-open');
                // console.log('Added mega-menu-open class to body'); // Removed
    }
        }
    };
  
    // Add event listeners
    if (allMenuButton) {
        allMenuButton.addEventListener('click', (e) => {
            // console.log('ALL MENU button clicked'); // Removed
    
            // Check if menu is already active - if so, close it
            if (allMenuButton.classList.contains('active')) {
                closeAllMenus();
                // console.log('Menu was active, closing it'); // Removed
            } else {
                // Otherwise open it
                toggleMenu(e);
                // console.log('Menu was not active, opening it'); // Removed
      }
        });
        
        // console.log('Added click listener to ALL MENU button'); // Removed
    }

    // Close menu when clicking outside
    if (overlay) {
        overlay.addEventListener('click', () => {
            // console.log('Overlay clicked, closing menus'); // Removed
            closeAllMenus();
  });
    }
  
    // Close menu when pressing ESC key
    document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
            // console.log('ESC key pressed, closing menus'); // Removed
            closeAllMenus();
        }
    });
    
    // Update menu visibility on resize
    window.addEventListener('resize', () => {
        // console.log('Window resized'); // Removed
        // Close any open menus to prevent UI issues
        closeAllMenus();
  });
  
    // Event: Window scroll 
    let lastScrollTop = 0;
    const scrollThreshold = 10; 
      
    window.addEventListener('scroll', () => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          
        if (header) { // Add null check for header
            if (scrollTop > 50) {
                header.classList.add('scrolled');
            } else {
                header.classList.remove('scrolled');
            }
            header.classList.remove('hidden'); // Ensure never hidden
        }
          
        const scrollDistance = Math.abs(scrollTop - lastScrollTop);
        if (scrollDistance > scrollThreshold) {
            if (allMenuButton && allMenuButton.classList.contains('active')) {
                closeAllMenus();
            }
            lastScrollTop = scrollTop; 
    }
  });
  
    // Add active class to current nav item
  const currentPath = window.location.pathname;
  const navItems = document.querySelectorAll('.header__nav-item, .header__mobile-nav-item, .mega-menu__link');
  
  navItems.forEach(item => {
    const itemPath = item.getAttribute('href');
    if (itemPath && (currentPath === itemPath || 
        (itemPath !== '/' && currentPath.startsWith(itemPath)))) {
      item.classList.add('active');
            // console.log('Set active nav item:', itemPath); // Removed
    }
  });
}
  // --- HEADER LOGIC END ---

  // --- FOOTER LOGIC START ---
  // Dynamically import footer script logic if needed, or place directly here
  try {
    import('/components/footer.js'); 
    // console.log('Footer script executed via import.'); // Removed
  } catch(error) {
      console.error('Failed to load footer script via import:', error)
  }
  // --- FOOTER LOGIC END ---
}

// No need for loadComponent or the old manual initialization/insertion functions
